import React from 'react'
import { Form as FormikForm } from 'formik'
import PropTypes from 'prop-types'

const Form = ({ children, ...formProps }) => (
  <FormikForm noValidate {...formProps}>
    {children}
  </FormikForm>
)

Form.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Form
